<template>
	<div>
		<v-dialog
			v-model="show"
			width="600"
			content-class="confirm-action-modal overflow-x-hidden"
			@click:outside="closeModal"
		>
			<v-card class="confirm-action-modal__card">
				<div
					:style="{
						justifyContent: isReport ? 'start' : 'center',
					}"
					class="d-flex mb-4 align-center flex-wrap"
				>
					<div class="confirm-action-modal__title text-center" v-html="title" />
				</div>
				<div v-if="isReport" class="confirm-action-modal__card__text-wrapper mb-4">
					<span class="confirm-action-modal__card__text-wrapper__title">Comment</span>
					<v-textarea
						class="confirm-action-modal__card__text-wrapper__textarea"
						v-model="innerValue"
						no-resize
						rows="6"
						hide-details="auto"
						placeholder="Comment..."
					></v-textarea>
				</div>
				<div class="button_group">
					<button
						style="border: 1.5px solid var(--accent-color)"
						type="button"
						class="confirm-action-modal__button action-cancel elevation-0"
						@click="closeModal"
					>
						Cancel
					</button>
					<button
						type="button"
						class="confirm-action-modal__button action-submit elevation-0"
						@click="confirmAction"
					>
						{{ actionName }}
					</button>
				</div>
				<button
					type="button"
					:disabled="isLoading"
					class="confirm-action-modal__button-close"
					style="background-color: #fff !important"
					@click="closeModal"
				>
					<v-icon color="#0055A3">mdi-close</v-icon>
				</button>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			default: '',
		},
		actionName: {
			type: String,
			default: '',
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		isReport: {
			type: Boolean,
			default: false,
		},
		value: {
			type: String,
			default: '',
		},
	},
	methods: {
		closeModal() {
			if (!this.isLoading) {
				this.$emit('closeModal')
			}
		},
		confirmAction() {
			if (!this.isLoading) {
				this.$emit('confirmAction')
			}
		},
	},
	computed: {
		innerValue: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', value)
			},
		},
	},
}
</script>

<style lang="scss">
.button_group {
	display: flex;
	justify-content: center;
	gap: 16px;
}
.confirm-action-modal {
	border-radius: 8px;

	&__card {
		padding: 24px;
		&__text-wrapper {
			display: flex;
			flex-direction: column;
			padding: 12px;
			border-radius: 8px;
			border: 1px solid #e2e2e2;
			&__title {
				font-family: 'Inter', sans-serif;
				font-weight: 500;
				font-size: 18px;
				line-height: 100%;
				letter-spacing: 0;
				color: #4a4a4a;
			}
			&__textarea {
				background-color: #ffffff;

				&:focus {
					.v-input__slot {
						border: 1px solid #000000;
					}
				}

				.v-input__slot {
					box-shadow: none !important;
					margin-bottom: 0 !important;

					&::before,
					&::after {
						display: none !important;
					}
				}
			}
		}
	}
	&__title {
		color: #4a4a4a;
		font-size: 24px;
		font-family: 'Inter', sans-serif;
		font-weight: 700;
		line-height: 100%;
		letter-spacing: 0;
	}
	&__button-close {
		position: absolute;
		top: 5px;
		right: 5px;
		width: 25px;
	}
	&__button {
		height: 46px;
		width: 146px;
		border-radius: 8px;
		font-family: 'Inter', sans-serif;
		font-size: 18px;
		font-weight: 700;
		text-transform: capitalize;

		&:disabled {
			border: none;
		}
	}
	.action {
		&-cancel {
			width: 146px !important;
			background: #fff !important;
			color: var(--primary_color) !important;
		}
		&-submit {
			width: 146px !important;
			background: var(--primary_color) !important;
			color: #fff !important;
		}
	}
}
</style>
